export const HEADER_HEIGHT = 40;
export const SOURCE_LOGO_WIDTH = 60;
export const BRANDING_LOGO_WIDTH = 100;
export const PROVIDER_LOGO_WIDTH = 100;

export default {
    header: {
        position: 'absolute',
        background: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%,rgba(0,0,0,0) 100%)',
        width: '100%',
        height: HEADER_HEIGHT,
        zIndex: 1000032,
        transition: 'transform 0.2s ease-out',
        color: '#fff',
        fontSize: 12,
        pointerEvents: 'none',
        paddingBottom: 5,
        fontFamily: '-apple-system, "Roboto", Helvetica, Arial, sans-serif'
    },
    show: {
        transform: 'translateY(0)'
    },
    hide: {
        transform: `translateY(-${HEADER_HEIGHT}px)`
    },
    logo: {
        float: 'left',
        width: SOURCE_LOGO_WIDTH,
        height: '100%',
        padding: '0 10px'
    },
    title: {
        height: '100%',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginLeft: SOURCE_LOGO_WIDTH,
        marginRight: BRANDING_LOGO_WIDTH
    },
    titleText: {
        verticalAlign: 'middle'
    },
    branding: {
        float: 'right',
        width: BRANDING_LOGO_WIDTH,
        height: '100%',
        padding: '0 10px',
        pointerEvents: 'all'
    },
    provider: {
        float: 'right',
        width: PROVIDER_LOGO_WIDTH,
        height: '100%',
        paddingRight: 10,
        pointerEvents: 'all',
        whiteSpace: 'nowrap',
        transition: 'width 0.2s'
    },
    logoImg: {
        verticalAlign: 'middle',
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        transition: 'width 0.2s'
    },
    signout: {
        display: 'inline-block',
        color: '#fff',
        width: 0,
        paddingLeft: 20,
        overflow: 'hidden',
        verticalAlign: 'middle'
    },
    separator: {
        verticalAlign: 'middle'
    },
    helper: {
        display: 'inline-block',
        height: '100%',
        verticalAlign: 'middle'
    }
};



// WEBPACK FOOTER //
// ./app/webapp/syndicated/PlayerOverlay/style.js